import { useEffect } from "react";

// The canonical, crawlable Privacy Policy is served as a static HTML file at
// /privacy.html (so Google's no-JS verification crawler can read it). This
// route simply forwards any in-app or bookmarked /privacy visit there.
export default function Privacy() {
  useEffect(() => {
    window.location.replace("/privacy.html");
  }, []);
  return null;
}
